import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_147: DocMigration = {
  maxSchemaVersion: "0.0.147",
  description: "Zero out exterior rooms with negative floor elevation",
  apply(json: any) {
    if (json.rooms) {
      for (const roomId in json.rooms) {
        const room = json.rooms[roomId];

        if (
          room.type !== "WALK" &&
          room.type !== "FRONT_PORCH" &&
          room.type !== "REAR_PORCH" &&
          room.type !== "PATIO"
        ) {
          continue;
        }

        if (room.floorElevationOffset !== undefined && room.floorElevationOffset < 0) {
          room.floorElevationOffset = undefined;
        }
      }
    }

    return json;
  },
};

export default migration_0_0_147;
